import { Spin, message } from "antd";
import { isAxiosError } from "axios";
import { useNavigate } from "react-router-dom";

import { useForgotPassword } from "@hooks";

import { LoginForgotPassword } from "@components/molecules";
import { ArrowLeft } from "@phosphor-icons/react";

export const ForgotPassword = () => {
  const navigate = useNavigate();

  const { forgotPassword, isLoading: isForgotPasswordLoading } = useForgotPassword();

  const handleForgotPassword = (data: { email: string }) => {
    forgotPassword.mutate(data.email, {
      onSuccess: () => {
        navigate("/login");
      },
      onError: (error) => {
        const defaultMessage = "Erro ao enviar seu email";
        if (isAxiosError(error)) {
          message.error(error.response?.data.message || defaultMessage);
        } else {
          message.error(defaultMessage);
        }
      },
    });
  };

  return (
    <Spin spinning={isForgotPasswordLoading}>
      <div className="flex min-h-screen bg-[url(/assets/images/bg-ruppert-ready-to-start.png)] bg-cover">
        <div className="hidden flex-1 flex-col justify-center p-10 relative md:flex">
          <div className="absolute top-5 left-5">
            <a
              href="https://www.ruppertinc.com/"
              className="text-gray-400! hover:text-white! flex items-center gap-2 text-xs font-light"
            >
              <ArrowLeft />
              Back to website
            </a>
          </div>

          <div className="absolute top-20 left-10 w-20">
            <img src='/assets/logos/ruppert-logo.svg' alt="Ruppert" />
          </div>
        </div>
        <div className="flex flex-col justify-center p-8 w-full md:max-w-md md:p-10">
          <h2 className="mb-10 flex justify-center md:justify-end">
            <img src="/assets/logos/ruppert-logo.svg" alt="Ruppert" className="w-40 md:w-20" />
          </h2>

          <LoginForgotPassword onFinish={handleForgotPassword} />
        </div>
      </div>
    </Spin>
  );
};
